import React from 'react';
import { Flex, Image } from 'pcln-design-system';
const LOGO_HEIGHTS = {
  sm: '40px',
  lg: '56px'
};
const FIXED_LOGO_HEIGHTS = {
  sm: '80px',
  md: '128px',
  lg: '160px'
};
const FIXED_LOGO_WIDTHS = {
  sm: '200px',
  md: '200px',
  lg: '200px'
};
const Logo = ({
  fixedLogoSize,
  isCondensed,
  logoImageUrl,
  showLogoImageBackground = true,
  lazyLoad = true,
  ...props
}) => {
  const logoHeight = isCondensed ? LOGO_HEIGHTS.sm : [LOGO_HEIGHTS.sm, null, LOGO_HEIGHTS.lg];
  return React.createElement(Flex, {
    alignItems: 'center',
    bg: showLogoImageBackground ? 'rgba(0, 0, 0, 0.7)' : 'transparent',
    borderRadius: 'lg',
    justifyContent: 'center',
    ...props
  }, React.createElement(Image, {
    height: fixedLogoSize ? FIXED_LOGO_HEIGHTS[fixedLogoSize] : logoHeight,
    loading: lazyLoad ? 'lazy' : 'eager',
    objectFit: 'contain',
    src: logoImageUrl,
    width: fixedLogoSize ? FIXED_LOGO_WIDTHS[fixedLogoSize] : undefined
  }));
};
export default Logo;